import React, { useState, useEffect } from 'react'
import './AgentList.css';
import { BiPlusMedical, BiSearchAlt } from 'react-icons/bi';
import { GoCloudDownload } from 'react-icons/go';
import { AiOutlineFileExcel } from 'react-icons/ai';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { getAgents } from '../../services/http';
import CustomDatatableAgent from '../../components/CustomDatatableAgent/CustomDatatableAgent';
import { handleMenuSelection, handleSubMenuSelection, searchFunction, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';


const AgentList = () => {

  const tableColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Nom" },
    { id: "3", label: "Prénom" },
    { id: "4", label: "Sexe" },
    { id: "5", label: "Téléphone" },
    { id: "6", label: "Email" },
    { id: "7", label: "Institution" },
  ]

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [perPage, setPerPage] = useState(15);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const states = useSelector((state) => state, shallowEqual);

  const [displayLoader, setDisplayLoader] = useState(true);


  // To populate the breadcrumb and update the sidebar menu
  useEffect(async () => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Agents", secondLevelLink: "/agent", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("settings", dispatch, states);
    handleSubMenuSelection("users", dispatch)
  }, [])


  const fetchAgents = async (page, search) => {
    let agent_list_response = await getAgents(states.userToken.access_token, page, search);
    let agent_list_response_copy = agent_list_response?.data.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false, showBlock: false, showUnblock: false }))
    console.log(agent_list_response)
    const perPageValue = agent_list_response?.data?.per_page
    setPerPage(perPageValue)
    const total = agent_list_response?.data?.total;
    setTotalPage(Math.ceil(total / perPageValue))
    dispatch({
      type: "SET",
      key: "agentList",
      payload: agent_list_response_copy,
    });
    setDisplayLoader(false);
  }

  useEffect(() => {
    fetchAgents(pageNumber, search)
    console.log(pageNumber)
    console.log(search)
  }, [pageNumber, search])



  const goToImportScreen = () => {
    navigate("/import-agent")
  }


  const handleShowNewCatModal = () => {
    navigate("/agent/new")
  };

  // Open block and unblock modal
  const handleShowBlockUnblockModal = (id, type) => {
    let index = states.agentList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.agentList];
    if (type == "block") {
      dispatch({
        type: "SET",
        key: "blockOrUnblockModal",
        payload: "block"
      });
      newTableData[index].showBlock = true
    }
    if (type == "unblock") {
      dispatch({
        type: "SET",
        key: "blockOrUnblockModal",
        payload: "unblock"
      });
      newTableData[index].showUnblock = true
    }


    dispatch({
      type: "SET",
      key: "agentList",
      payload: newTableData,
    });
  };
  // Close block unblock modal
  const handleCloseBlockUnblockModal = (id, type) => {
    let index = states.agentList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.agentList];
    if (type == "block") {
      dispatch({
        type: "SET",
        key: "blockOrUnblockModal",
        payload: ""
      });
      newTableData[index].showBlock = false
    }
    if (type == "unblock") {
      dispatch({
        type: "SET",
        key: "blockOrUnblockModal",
        payload: ""
      });
      newTableData[index].showUnblock = false
    }

    dispatch({
      type: "SET",
      key: "agentList",
      payload: newTableData,
    });
  };

  const handleCloseDeleteModal = (id) => {
    let index = states.agentList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.agentList];
    newTableData[index].showDelete = false;

    dispatch({
      type: "SET",
      key: "agentList",
      payload: newTableData,
    });
  };
  const handleShowDeleteModal = (id) => {
    let index = states.agentList.findIndex(x => x.id === id);
    // console.log("index is : ", index)
    let newTableData = [...states.agentList];
    newTableData[index].showDelete = true;
    dispatch({
      type: "SET",
      key: "agentList",
      payload: newTableData,
    });
  };


  const handleSearchChange = (e) => {
    console.log(e.currentTarget.value)
    setSearch(e.currentTarget.value)
  }

  const changePage = ({ selected }) => {
    let currentPage = selected + 1;
    setPageNumber(currentPage)
  }

  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            {/* <AddOrEditInstitutionCategory onExit={reload} operationType={"new"} show={states.showNewInstitutionCategory} handleClose={handleCloseNewCatModal} /> */}
            <h2 className="mb-2  text-left">Liste des agents</h2>
            {displayLoader == false ?
            <div className="widget widget-content widget-content-area">
              <div className="dataTables_wrapper  dt-bootsrap4">
                <div className="dt--top-section container-fluid mt-4 pt-3 px-3">
                  <div className="row">
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center mb-3">
                      <form class="form-inline justify-content-center search-input-container mb-3">
                        <div class="w-100 d-flex flex-nowrap search-input-container">
                          <input type="text" onChange={handleSearchChange} class=" form-control product-search br-30" id="input-search" placeholder="Rechercher..." />

                        </div>
                      </form>
                    </div>
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center mb-3 mt-sm-0 mt-3">
                      {states.userPermissions?.create_user !== undefined && <div>
                        <button className="btn btn-info mb-2" onClick={() => handleShowNewCatModal()}> <BiPlusMedical className="" /> Ajouter</button>
                        <button className="btn btn-dark ml-3 mb-2" onClick={goToImportScreen}><AiOutlineFileExcel className="mr-1" />Importer</button>
                      </div>}
                    </div>
                  </div>
                </div>


                {states.agentList && states.agentList.length != 0 ?
                  <CustomDatatableAgent 
                    columns={tableColumns}
                    data={states.agentList}
                    handleCloseBlockUnblockModal={handleCloseBlockUnblockModal}
                    handleShowBlockUnblockModal={handleShowBlockUnblockModal}
                    handleCloseDeleteModal={handleCloseDeleteModal}
                    handleShowDeleteModal={handleShowDeleteModal}
                    changePage={changePage}
                    pageCount={totalPage}
                    pageNumber={pageNumber}
                    perPage={perPage}
                  /> : <h4 className="py-3">Aucun résultat</h4>}
              </div>
            </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}
          </div>


        </div>

      </div>
    </div>
  )
}

export default AgentList
